import React from 'react';
import AuthPage from 'App/components/AuthPage';

const propTypes = {};

const defaultProps = {};

function InCompleteConfiguration() {
    return (
        <AuthPage>
            <h2 className="title">You&apos;re almost there!</h2>
            <p className="desc">
                Please contact your pharmacy&apos;s TherigySTM Company or Branch Administrator to assign the appropriate
                role(s) and privileges to your account.
            </p>
            <p className="desc">Once assigned, you will be able to successfully access TherigySTM.</p>
        </AuthPage>
    );
}

InCompleteConfiguration.propTypes = propTypes;
InCompleteConfiguration.defaultProps = defaultProps;

export default InCompleteConfiguration;
